module.exports = __webpack_public_path__ + "static/media/syringe-bottle.833c81ba.svg";